import {
  API_ERROR,
  GET_PERMSTIONS_LIST,
  GET_PERMSTIONS_LIST_SUCCESSFULL,
  CHECK_PERMSSION,
  CHECK_PERMSSION_FILED,
  SUBMIT_PROFILE,
  GET_PROFILE_DATA,
  GET_PROFILE_DATA_SUCCESSFULL,
  INPUT_CHANGEVALUE,
} from "./actionTypes";
export const GetPermstionsList = (id) => {
  return {
    type: GET_PERMSTIONS_LIST,
    payload: { id },
  };
};
export const GetPermstionsListSuccessful = (response) => {
  return {
    type: GET_PERMSTIONS_LIST_SUCCESSFULL,
    payload: response,
  };
};
export const checkPermssion = (permID) => {
  return {
    type: CHECK_PERMSSION,
    payload: { permID },
  };
};
export const permissionFiled = (permID, filedID) => {
  return {
    type: CHECK_PERMSSION_FILED,
    payload: { permID, filedID },
  };
};
export const SubmitProfile = (data, profileID, history) => {
  return {
    type: SUBMIT_PROFILE,
    payload: { data, profileID, history },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const getProfiledata = (id) => {
  return {
    type: GET_PROFILE_DATA,
    payload: { id },
  };
};
export const getProfiledataSuccessful = (response) => {
  return {
    type: GET_PROFILE_DATA_SUCCESSFULL,
    payload: response,
  };
};
// export const apiError = (error) => {
//   return {
//     type: API_ERROR,
//     payload: error,
//   };
// };
